import { Bell, CalendarDays, CalendarPlus, HeartPulse, Smartphone } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';
import { DemoCaption, PhoneFrame } from '../compass/shared';

const ITEM_ICONS = {
  'Employee Mobile Access': Smartphone,
  'Holiday Requests': CalendarPlus,
  'Leave Calendar': CalendarDays,
  'Sickness Records': HeartPulse,
  'Notifications': Bell,
};

// Section 6 — employees, leave and sickness: employee self-service with
// management control. Visually distinct editorial rows + mobile visual.
export const PulseEmployees = ({ sp }) => (
  <section aria-labelledby="pulse-employees-heading" data-testid="pulse-employees" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid items-center gap-14 lg:grid-cols-2">
        <Reveal className="order-last lg:order-first">
          <PhoneFrame shot={sp.shots.employeeMobile} className="mx-auto max-w-[280px]" />
          <DemoCaption />
        </Reveal>
        <Reveal delay={0.1}>
          <SectionHeader
            align="left"
            eyebrow="Employees, Leave & Sickness"
            title="Give employees a simpler way to manage everyday requests"
            testid="pulse-employees-header"
          />
          <ul className="mt-10 space-y-6">
            {(sp.employeeItems || []).map((item, i) => {
              const Icon = ITEM_ICONS[item.title] || Smartphone;
              return (
                <li key={item.title} className="flex items-start gap-4" data-testid={`pulse-employee-item-${i + 1}`}>
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-gold-200 bg-gold-50 text-gold-700">
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </span>
                  <div>
                    <h3 className="text-base font-extrabold tracking-tight text-navy-900">{item.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-slate-600">{item.text}</p>
                  </div>
                </li>
              );
            })}
          </ul>
        </Reveal>
      </div>
    </div>
  </section>
);
